import React from 'react'
import styles from './SuccessStory.module.css'
import type { SuccessStoryItem } from './types'

export default function SuccessStoryBox({
    items,
}: {
    items: SuccessStoryItem[]
}) {
    return (
        <div className={styles.successStoryBox}>
            {items.map((item, index) =>
                item.external !== false ? (
                    <a
                        key={index}
                        target='_blank'
                        rel='noopener noreferrer'
                        href={item.href}
                    >
                        <img src={item.src} alt={item.alt} />
                    </a>
                ) : (
                    <a key={index} href={item.href}>
                        <img src={item.src} alt={item.alt} />
                    </a>
                )
            )}
        </div>
    )
}
